import { recipe } from "@vanilla-extract/recipes";
import { theme } from "../../theme/css/theme.css";
import { style } from "@vanilla-extract/css";

export const tableStyle = recipe({
  base: {
    width: "100%",
    borderCollapse: "collapse",
  },
  variants: {},
  defaultVariants: {},
});

export const generalTableCellStyle = recipe({
  base: {},
  variants: {
    align: {
      left: {
        textAlign: "left",
      },
      center: {
        textAlign: "center",
      },
      right: {
        textAlign: "right",
      },
    },
    bold: {
      true: {
        fontWeight: "bold",
      },
    },
  },
  defaultVariants: {
    align: "left",
  },
});

export const tableHeaderStyle = style({
  padding: `0 ${theme.spacings.s} ${theme.spacings.xxs} 0`,
  ":last-child": {
    paddingRight: 0,
  },
});

export const tableCellStyle = recipe({
  base: {
    padding: `${theme.spacings.s} ${theme.spacings.s} ${theme.spacings.s} 0`,
    ":last-child": {
      paddingRight: 0,
    },
  },
  variants: {
    variant: {
      default: {
        borderBottom: `1px solid ${theme.colors.defaultBorder}`,
      },
    },
    lastRow: {
      true: {
        borderBottom: "none",
        paddingBottom: 0,
      },
    },
  },
  defaultVariants: {
    variant: "default",
  },
});
